module.exports = __webpack_public_path__ + "static/media/battery_80.d31eaad3.svg";